import { Device, HorizontalContainer, useDeviceViewport, withTheme } from '@se-admin/falcon';
import * as React from 'react';
import { UserContext } from '../../common/contexts/index';
import { ISale } from '../../common/types/apiSchema';
import { SaleCard, SaleCardVariant } from '../SaleCard/index';
import { saleCardWrappedSkeletonList } from '../SaleCard/SaleCardSkeleton/SaleCardSkeleton.utils';
import { IHorizontalSaleListProps } from './HorizontalSaleList.interfaces';
import { WrappedSaleCard } from './HorizontalSaleList.style';

/**
 * How many sales should be displayed on desktop
 */
export const DISPLAY_DESKTOP_SALES_NUMBER: number = 4;

/**
 * Displays a list of sales in a horizontal container
 */
const HorizontalSaleList: React.FunctionComponent<IHorizontalSaleListProps> = ({
  affiliate,
  sales,
  baseUrl,
  title,
  loading,
}) => {
  const deviceViewport: Device = useDeviceViewport();
  const { userId } = React.useContext(UserContext);

  let displaySales: ISale[] = [];
  if (sales) {
    if (deviceViewport === Device.mobile) {
      displaySales = sales;
    } else {
      displaySales = sales.slice(0, DISPLAY_DESKTOP_SALES_NUMBER);
    }
  }

  const salesArray: JSX.Element[] = loading
    ? saleCardWrappedSkeletonList(DISPLAY_DESKTOP_SALES_NUMBER, SaleCardVariant.small)
    : displaySales.map((sale, index) => {
        return (
          <WrappedSaleCard key={sale.id}>
            <SaleCard
              key={sale.id}
              sale={sale}
              variant={SaleCardVariant.small}
              userId={userId}
              affiliateDetails={affiliate}
              baseUrl={baseUrl}
              trackingPosition={index}
            />
          </WrappedSaleCard>
        );
      });

  return <HorizontalContainer title={title}>{salesArray}</HorizontalContainer>;
};

export default withTheme(HorizontalSaleList);
